import { Box, Typography } from "@mui/material"

const LandingFeatureListItem = ({ icon: Icon, title, description }) => (
    <Box className="landing-feature-list-item">
        <Box className="landing-feature-list-item__icon-wrap">
            <Icon className="landing-feature-list-item__icon" />
        </Box>
        <Box className="landing-feature-list-item__content">
            <Typography component="h3" className="landing-feature-list-item__title">
                {title}
            </Typography>
            <Typography component="p" className="landing-feature-list-item__description">
                {description}
            </Typography>
        </Box>
    </Box>
)

export default LandingFeatureListItem